import React from 'react'

interface SvgCheckmarkProps {
  width?: number
  height?: number
  size?: 'md' | 'sm'
}

const SvgCheckmarkNoFill = ({
  width = 24,
  height = 24,
  size = 'md',
  ...otherProps
}: React.SVGProps<SVGSVGElement> & SvgCheckmarkProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      {(typeof size === 'undefined' || size === 'md') && (
        <path
          className="fill-current"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.76 9.65a1 1 0 00-1.52-1.3l-5.296 6.18-3.237-3.237a1 1 0 00-1.414 1.414l4 4a1 1 0 001.466-.056l6-7z"
        />
      )}
      {size === 'sm' && (
        <path
          className="fill-current"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0ZM12.5926 6.65079C12.952 6.23147 12.9035 5.60017 12.4841 5.24074C12.0648 4.88132 11.4335 4.92988 11.0741 5.34921L7.77685 9.19597L5.87377 7.29289C5.48325 6.90237 4.85008 6.90237 4.45956 7.29289C4.06904 7.68342 4.06904 8.31658 4.45956 8.70711L7.12623 11.3738C7.32319 11.5707 7.59337 11.6766 7.87171 11.6659C8.15005 11.6552 8.41132 11.5289 8.59259 11.3175L12.5926 6.65079Z"
          fill="#00A175"
        />
      )}
    </svg>
  )
}

export default SvgCheckmarkNoFill
